import {
    SALEORDER_UPDATE_PRODUCT,
    SALEORDER_UPDATE_PROJECT,
    SALEORDER_UPDATE_CUSTOMER,
    SALEORDER_UPDATE_YEARSPAYMENT,
    SALEORDER_UPDATE_CAMPAIGN,
    SALEORDER_UPDATE_INITIAL_QUOTA,
    SALEORDER_UPDATE_PAYMENTCONDITION,
    SALEORDER_NEGOTIATE,
    SALEORDER_CLEAN_NEGOTIATE,
    SALEORDER_UPDATE_SPOTTREESELECTION,
    SALEORDER_SUCCESSFUL_POST,
    SALEORDER_CLEAN_STATE,
    SALEORDER_SUCCESSFUL_GET,
    SALEORDER_SUCCESSFUL_UPDATE_PRODUCT,
    SALEORDER_SUCCESSFUL_UPDATE_NEGOTIATION,
    SECOND_SALEORDER_QUALIFICATION_SUCCESSFUL_GET
} from 'reducers/constants';

import { formatToDecimal, roundNumber } from 'utils/Number/NumberUtils';

const initialState = initState();


function initState() {
    return {
        customer: null,
        paymentCondition: null,
        project: null,
        product: null,
        yearsPayment: null,
        campaign: null,
        initialQuota: null,
        canEditInitialQuota: true,
        negotiationSaleOrder: null,
        spotNodeSelected: null,
        saleOrder: null,
        saleOrdersDto: {
            count: 0,
            data: []
        },
        enabledForSecondSale: false
    };
}

export default function (state = initialState, action) {
    switch (action.type) {

        case SALEORDER_UPDATE_PRODUCT:
            return {
                ...state,
                product: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case SALEORDER_UPDATE_PROJECT:
            return {
                ...state,
                project: Object.assign({}, action.payload)
            }

        case SALEORDER_UPDATE_CUSTOMER:
            return {
                ...state,
                customer: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case SALEORDER_UPDATE_YEARSPAYMENT:
            return {
                ...state,
                yearsPayment: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case SALEORDER_UPDATE_CAMPAIGN:
            return {
                ...state,
                campaign: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case SALEORDER_UPDATE_INITIAL_QUOTA:
            return {
                ...state,
                initialQuota: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case SALEORDER_UPDATE_PAYMENTCONDITION:
            return {
                ...state,
                paymentCondition: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case SALEORDER_NEGOTIATE:
            return {
                ...state,
                negotiationSaleOrder: action.payload != null ? Object.assign({}, action.payload) : null
            }

        case SALEORDER_CLEAN_NEGOTIATE:
            return {
                ...state,
                negotiationSaleOrder: null
            }

        case SALEORDER_UPDATE_SPOTTREESELECTION:
            return {
                ...state,
                spotNodeSelected: action.payload != null ? action.payload : null
            }

        case SALEORDER_SUCCESSFUL_POST:
        console.log("SALEORDER_SUCCESSFUL_POST", action.payload);
        const form = action.payload;
        form.financeBalanceFormatted = formatToDecimal(roundNumber(form.financeBalance, 2));
        form.finalPaymentFormatted = formatToDecimal(roundNumber(form.finalPayment, 2));
        form.quickPaymentFormatted = formatToDecimal(roundNumber(form.quickPayment, 2));
        console.log("productStatus", getProductStatus(form.product.productStatus));
            return {
                ...state,
                saleOrder: action.payload,
                product: Object.assign({}, {
                    id: form.product.id,
                    name: form.product.name,
                    lotNumber: form.product.lotNumber,
                    neighborhoodUnit: form.product.neighborhoodUnit,
                    block: form.product.block,
                    code: form.product.code,
                    surface: form.product.surface,
                    price: form.product.price,
                    projectName: form.selectedSaleOrder.project.name,
                    totalPrice: form.quickPaymentFormatted,
                    initialQuota: form.initialQuota,
                    monthlyQuota: form.monthlyQuota,
                    status: getProductStatus(form.product.productStatus)
                })
            }

        case SALEORDER_CLEAN_STATE:
            return initState();

        case SALEORDER_SUCCESSFUL_GET:
            console.log("SALEORDER_SUCCESSFUL_GET", action.payload);
            const saleOrderForm = action.payload;
            saleOrderForm.financeBalanceFormatted = formatToDecimal(roundNumber(saleOrderForm.financeBalance, 2));
            saleOrderForm.finalPaymentFormatted = formatToDecimal(roundNumber(saleOrderForm.finalPayment, 2));
            saleOrderForm.quickPaymentFormatted = formatToDecimal(roundNumber(saleOrderForm.quickPayment, 2));
            console.log("productStatus", getProductStatus(saleOrderForm.product.productStatus));
            return {
                ...state,
                project: { value: saleOrderForm.product.projectId, label: "" },
                product: Object.assign({}, {
                    id: saleOrderForm.product.id,
                    name: saleOrderForm.product.name,
                    lotNumber: saleOrderForm.product.lotNumber,
                    neighborhoodUnit: saleOrderForm.product.neighborhoodUnit,
                    block: saleOrderForm.product.block,
                    code: saleOrderForm.product.code,
                    surface: saleOrderForm.product.surface,
                    price: saleOrderForm.product.price,
                    projectName: saleOrderForm.selectedSaleOrder.project.name,
                    totalPrice: saleOrderForm.quickPaymentFormatted,
                    initialQuota: saleOrderForm.initialQuota,
                    monthlyQuota: saleOrderForm.monthlyQuota,
                    status: getProductStatus(saleOrderForm.product.productStatus)
                }),
                customer: { id: saleOrderForm.customerIdS, completeName: saleOrderForm.customerCompleteName },
                paymentCondition: { value: saleOrderForm.paymentConditionType, label: '' },
                yearsPayment: { value: saleOrderForm.yearsPayment, label: '' },
                campaign: { value: saleOrderForm.campaign, label: '' },
                initialQuota: saleOrderForm.initialQuota,
                negotiationSaleOrder: saleOrderForm ? Object.assign({}, saleOrderForm) : null,
            }

        case SALEORDER_SUCCESSFUL_UPDATE_PRODUCT:
            return {
                ...state
            }

        case SALEORDER_SUCCESSFUL_UPDATE_NEGOTIATION:
            return {
                ...state
            }

        case SECOND_SALEORDER_QUALIFICATION_SUCCESSFUL_GET:
            const data = action.payload;
            return {
                ...state,
                enabledForSecondSale: data.value
            }

        default:
            return state;

    }
}

function getProductStatus(status) {
    if (status === 'SALE_AVAILABLE') {
        return "DISPONIBLE PARA LA VENTA";
    }
    if (status === 'BLOCKED') {
        return "BLOQUEADO";
    }
    if (status === 'RESERVED') {
        return "RESERVADO";
    }
    if (status === 'SOLD') {
        return "VENDIDO";
    }
    if (status === 'PAID') {
        return "PAGADO";
    }
}



// WEBPACK FOOTER //
// ./src/reducers/saleorder/saleorderReducer.js